import React, { useEffect } from 'react';
import { logout } from '../../utils/auth-utils';
import CircularLoader from '../CircularLoading/CircularLoading';
import { obj } from '../../userData/UserKycStatus';
import Toast from '../../../common/components/Toast/Toast';
import { isLoggedIn } from '../../utils/cookie-utils';
import { unRegister } from '../../../../../lems-ui/src/common/Firebase/Firebase';

const Logout = async () => {
  let loggedOut = false;
  obj.isFirstLoadKYC = true;
  if (isLoggedIn()) {
    loggedOut = logout();
    Toast('info', 'You have been logged out!', 3000, 'top-right');
  }
  if (!loggedOut) return <CircularLoader />;
  else {
    return null;
  }
};
export default Logout;
